import React from 'react'
import ProfileChargeRow from './ProfileChargeRow'
import withView from '../../cmn/docAutomation/withView';
import FormTitle from '../../../library/form/components/FormTitle'
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormButton from '../../../library/form/components/FormActionButton2';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../library/layout/Index";
import FormInput from '../../../library/form/components/FormInput';

const ProfileCharge = (props) => {
    const { formObject, viewData } = props;
    if (!viewData)
        return (null)

    return (
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span>
                            <FormTitle formObject={formObject} value='Charges Details' />
                        </span>
                    </UiTitle>
                    <UiAction>
                        <FormInput formObject={formObject}  ksc="c" headerKey="headerRows" className="uiInput"
                                action={{ InputType: "ac", paramName: "importFromProfile", acMethod: "ParentProfileName", acDepCtrl: { dparam: "%dataList.valLDT", reqPerm: 1} }}
                                placeholder="Select Company to Import"/>
                        <FormButton formObject={formObject} ksc="c" headerKey="headerRows"
                            action={{ refreshMode:"self", actionId: "new", actionParam: {importFromProfile: "#importFromProfile", actionType : "importProfileCharge"} }}
                            className='uiActionButton' text={<SarasTrans value="Import Charge" />}></FormButton>
                        <FormButton formObject={formObject} ksc="c" rowKey="" starIcon={"adds"}
                            action={{ actionId: "new",  actionParam: {}, containerKey: "row" }}
                            className="uiActionIconButton" text={<SarasTrans value="Add Charge" />}></FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="ID" /></li>
                                <li className="uiColumnCenter uiColumn200 "><SarasTrans value="Type" /></li>
                                <li className="uiColumnCenter uiColumn200"><SarasTrans value="Item" /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Value" /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Tax" /></li>
                                <li className="uiColumnCenter uiColumn100"><SarasTrans value="Action" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData).map((row, index) => (
                                <ProfileChargeRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
    )
}

export default withView(ProfileCharge, "proCharge", "")